import * as Scrivito from "scrivito";

const GalleryWidget = Scrivito.provideWidgetClass("GalleryWidget", {
  attributes: {
    dotsDescription: "string",
    images: ["referencelist", { only: ["Image"] }],
  },
});

export default GalleryWidget;
